module.exports = __webpack_public_path__ + "img/checked_crime.742c2b00.png";